import type {
  UndecoratedKeypoint,
  UndecoratedNote,
  UndecoratedNoteFile,
} from '@witmetrics/utils';
import { sortByCreatedAt } from '@witmetrics/utils/arrays';
import type { TimelineItemType } from '@witmetrics/unison-core';
import type { TimelineItem } from './types';
import { ITEM_TYPE } from './constants';

export const classes = {
  wrapper: 'flex flex-col',
};

export function sortItems(
  timelineSettings: TimelineItemType,
  keypoints: UndecoratedKeypoint[],
  notes: UndecoratedNote[],
  fileNotes: UndecoratedNoteFile[]
): TimelineItem[] {
  const keypointItems = keypoints.map((k) => ({
    itemType: ITEM_TYPE.KEYPOINT,
    createdAt: k.createdAt,
    content: k,
  }));
  const noteItems = [
    ...notes.map((content) => ({
      itemType: ITEM_TYPE.NOTE,
      createdAt: content.createdAt,
      content,
    })),
    ...fileNotes.map((content) => ({
      itemType: ITEM_TYPE.FILE_NOTE,
      createdAt: content.createdAt,
      content,
    })),
  ];
  if (timelineSettings === 'KEYPOINTS') {
    return sortByCreatedAt(keypointItems);
  } else if (timelineSettings === 'NOTES') {
    return sortByCreatedAt(noteItems);
  } else {
    return sortByCreatedAt([...keypointItems, ...noteItems]);
  }
}
